export const MODULES_QUERY_KEYS = {
  all: ["MODULES"] as const,
  questions: (moduleID: string) =>
    [...MODULES_QUERY_KEYS.all, "QUESTIONS", moduleID] as const,
} as const;
